<template>
  <div>
    <v-card class="pa-4">
      <div v-if="proposalData">
        <h3>Proposal Id: {{proposalData.proposalId}}</h3>
        <v-divider class="my-2"></v-divider>
        <div>
          <div class="text-caption" v-if="proposalData.startTime">
            <span class="font-weight-medium">Start Time: </span>
            {{new Date(proposalData.startTime * 1000).toUTCString()}}
          </div>
          <div class="text-caption" v-if="proposalData.endTime">
            <span class="font-weight-medium">End Time: </span>
            <span class="text-caption" :class="((proposalData.endTime * 1000) < currentTimestamp) ? 'red--text' : ''">
              {{new Date(proposalData.endTime * 1000).toUTCString()}}
            </span>
          </div>
          <div class="text-caption" v-if="votingPeriods">
            <span class="font-weight-medium">Voting Periods: </span>
            {{votingPeriods}} days
          </div>
          <div class="text-caption">
            <span class="font-weight-medium">Spending Requirement: </span>
            {{proposalData.spendingRequirement / (10 ** paymentCoinDecimal)}} USDC
          </div>
        </div>
        <v-divider class="my-2"></v-divider>
      </div>

      <h4 class="mb-2 grey--text text--darken-1">Content: </h4>
      <div>
        {{proposalContent.content}}
      </div>
      <h4 class="my-2 grey--text text--darken-1">Voting Options: </h4>
      <v-radio-group v-model="selectedOption" dense hide-details class="mt-0" :disabled="editable===false || !!votedOption">
        <v-radio
            v-for="(votingOption, index) in proposalContent.options"
            :key="index"
            :label="votingOption + '  [' + (!votingResult[(index + 1).toString()] ? '0' : votingResult[(index + 1).toString()]) + ']'"
            :value="index + 1"
        ></v-radio>
      </v-radio-group>
      <slot name="voteConfirm" v-bind="{proposalData, selectedOption}"></slot>
    </v-card>
  </div>
</template>

<script>

import config from "@/config";

export default {
  name: "ProposalCard",
  props: {
    editable: Boolean,
    votingPeriods: Number,
    proposalData: Object,
    proposalContent: Object,
    votingResult: {
      type: Object,
      default: () => ({})
    },
    votedOption: Number
  },
  mounted() {
    if (this.votedOption) {
      this.selectedOption = this.votedOption
    }
  },
  computed: {
    paymentCoinDecimal() {
      return config.commonConfig.paymentCoinDecimal
    }
  },
  data(){
    return {
      selectedOption: null,
      currentTimestamp: new Date()
    }
  }
}
</script>

<style scoped>

</style>